export const standardSizeSort = (sizes: string[]) => {
  const baseOrder = ['S', 'M', 'L']

  const normaliseSize = (size: string) => {
    const upperCase = size.toUpperCase()
    if (/^\d{1,2}X[A-Z]$/.test(upperCase)) {
      return upperCase.replace('X', '')
    }

    const parts = upperCase.split('X')
    const xCount = parts.length - 1
    return `${xCount}${parts.slice(-1)[0]}`
  }

  const normalisedSizes = sizes.map((size) => ({
    size,
    normalised: normaliseSize(size),
  }))

  const sortedSizes = normalisedSizes.sort((a, b) => {
    const regex = /(\d{1,2})([A-Z])+$/
    const [, multiplierA, sizeA] = a.normalised.match(regex) ?? []
    const [, multiplierB, sizeB] = b.normalised.match(regex) ?? []

    const aIndex = baseOrder.indexOf(sizeA)
    const bIndex = baseOrder.indexOf(sizeB)

    if (aIndex === bIndex) {
      return sizeA === 'S'
        ? Number(multiplierB) - Number(multiplierA)
        : Number(multiplierA) - Number(multiplierB)
    }

    return aIndex - bIndex
  })

  return sortedSizes.map(({ size }) => size)
}
